import { Component, OnInit, Inject } from '@angular/core';
import {environment} from '../../environments/environment';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';



@Component({
	selector: 'app-view-user',
	templateUrl: './view-user.component.html',
	styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent implements OnInit {

	public apiUrl = environment.apiUrl;

	public userDetails: any;

	constructor(
		public dialogRef: MatDialogRef<ViewUserComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) { }

	ngOnInit() {
		this.userDetails = JSON.parse(JSON.stringify(this.data.userDetails));
		console.log(this.data);
	}

	closeDialog() {
		this.dialogRef.close({ changedUser: this.userDetails });
	}

}



// WEBPACK FOOTER //
// ./src/app/view-user/view-user.component.ts